import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatRupiah } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { useCart } from "../contexts/CartContext";
import { Check, Sparkles, Crown } from "lucide-react";
import { toast } from "sonner";

export default function Subscriptions() {
  const [plans, setPlans] = useState([]);
  const { user } = useAuth();
  const { addItem } = useCart();
  const navigate = useNavigate();
  useEffect(() => { api.get("/subscriptions").then(r => setPlans(r.data)); }, []);

  const subscribe = (p) => {
    if (!user) {
      toast.info("Login dulu untuk berlangganan");
      navigate("/login", { state: { from: { pathname: "/subscriptions" } } });
      return;
    }
    addItem({ item_type: "subscription", item_id: p.id, title: p.title, price: p.price, image: "" });
    toast.success("Plan ditambahkan ke keranjang");
    navigate("/checkout");
  };

  return (
    <div data-testid="subscriptions-page">
      <section className="lumina-bg-soft py-20">
        <div className="lumina-container text-center">
          <div className="lumina-label mb-3 inline-block">Membership</div>
          <h1 className="font-serif text-5xl md:text-6xl tracking-tighter text-[#1A1728] mb-6 max-w-3xl mx-auto">Investasi terbaik untuk <em className="text-[#6B4BA3] italic font-normal">dirimu sendiri</em>.</h1>
          <p className="text-lg text-[#5C5870] max-w-2xl mx-auto">Berlangganan untuk akses tanpa batas ke konseling, tes, dan produk digital — dengan harga yang lebih ramah.</p>
        </div>
      </section>
      <section className="lumina-container py-16">
        <div className="grid md:grid-cols-3 gap-6">
          {plans.map(p => (
            <div key={p.id} className={`lumina-card p-8 flex flex-col ${p.is_popular ? "border-[#6B4BA3] ring-2 ring-[#6B4BA3]/20" : ""}`} data-testid={`sub-card-${p.slug}`}>
              {p.is_popular && (
                <div className="inline-flex items-center gap-1 self-start bg-[#6B4BA3] text-white text-xs font-medium px-3 py-1 rounded-full mb-4">
                  <Crown className="w-3 h-3" /> POPULER
                </div>
              )}
              <h3 className="font-serif text-3xl text-[#1A1728] mb-2">{p.title}</h3>
              <p className="text-sm text-[#5C5870] mb-6 leading-relaxed">{p.description}</p>
              <div className="mb-6">
                <div className="font-serif text-5xl text-[#6B4BA3]">{formatRupiah(p.price)}</div>
                <div className="text-xs text-[#5C5870] uppercase tracking-widest mt-1">per {p.billing_period === "yearly" ? "tahun" : "bulan"}</div>
              </div>
              <ul className="space-y-3 mb-8 flex-1">
                {p.features.map((f, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm">
                    <Check className="w-4 h-4 text-[#6B4BA3] shrink-0 mt-0.5" /> <span>{f}</span>
                  </li>
                ))}
              </ul>
              <button onClick={() => subscribe(p)} className={p.is_popular ? "lumina-btn-primary" : "lumina-btn-outline"} data-testid={`subscribe-${p.slug}`}>
                <Sparkles className="w-4 h-4" /> Pilih Plan
              </button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
